// Centralised quality token registry. Keep names stable, they go to the backend.
export const QUALITIES = [
  { value: "correct", label: "Correct", color: "#2563EB", description: "Meets breed standard" },
  { value: "improve", label: "Could be improved", color: "#171717", description: "Acceptable but not ideal" },
  { value: "faulty", label: "Faulty", color: "#DC2626", description: "A clear fault" },
  { value: "serious", label: "Serious fault / DQ", color: "#9CA3AF", description: "Serious fault or disqualification" },
  { value: "unknown", label: "Unknown / not entered", color: "#E5E7EB", description: "No data recorded" },
];

export const QUALITY_COLOR = QUALITIES.reduce((acc, q) => {
  acc[q.value] = q.color;
  return acc;
}, {});

export const BODY_PARTS = [
  { key: "ears", label: "Ears" },
  { key: "head", label: "Head" },
  { key: "neck", label: "Neck" },
  { key: "front", label: "Front" },
  { key: "back", label: "Back" },
  { key: "rear", label: "Rear" },
  { key: "tail", label: "Tail" },
];

export const emptyParts = () => ({
  ears: "unknown",
  head: "unknown",
  neck: "unknown",
  front: "unknown",
  back: "unknown",
  rear: "unknown",
  tail: "unknown",
});

export const emptyAncestor = () => ({
  name: "",
  sex: "unknown",
  registration: "",
  title: "",
  dob: "",
  notes: "",
  photo_path: "",
  genetics: "",
  medical_conditions: "",
  standard_compliance: "",
  parts: emptyParts(),
});

// Heap-style indexing: 0 = subject, sire(i) = 2i+1, dam(i) = 2i+2
export const SIRE = (i) => 2 * i + 1;
export const DAM = (i) => 2 * i + 2;
export const totalAncestors = (gens) => Math.pow(2, gens) - 1;

// Returns the generation index of node i (0 = subject)
export const generationOf = (i) => Math.floor(Math.log2(i + 1));

// Position-in-generation (0-indexed from top) for node i
export const indexInGeneration = (i) => i - (Math.pow(2, generationOf(i)) - 1);
